import styled from '@emotion/styled';
import { css } from '@emotion/react';
// Default theme for BaseButton
export const chatModalTheme = {
    breakpoints: {
        sm: '640px',
        md: '768px',
        lg: '1024px',
        xl: '1280px'
    }
};
export const ChatModalWrapper = styled.div`
  /* Theme CSS Variables for BaseButton compatibility */
  --theme-primary: rgb(16 185 129);
  --theme-primary-dark: rgb(5 150 105);
  --theme-primary-darker: rgb(4 120 87);
  --theme-primary-text: white;
  
  --theme-secondary: rgb(147 197 253);
  --theme-secondary-text: rgb(30 58 138);
  
  --theme-danger: rgb(239 68 68);
  --theme-danger-dark: rgb(220 38 38);
  --theme-danger-darker: rgb(185 28 28);
  --theme-danger-text: white;
  
  --theme-border: rgb(229 231 235);
  --theme-border-dark: rgb(209 213 219);
  
  --theme-text: rgb(17 24 39);
  --theme-text-secondary: rgb(107 114 128);
  --theme-text-muted: rgb(156 163 175);
  
  --theme-paper: white;
  --theme-paper-hover: rgb(249 250 251);
  --theme-paper-active: rgb(243 244 246);
  
  /* Dark mode overrides */
  .dark & {
    --theme-primary: rgb(52 211 153);
    --theme-primary-dark: rgb(16 185 129);
    --theme-primary-darker: rgb(5 150 105);
    
    --theme-secondary: rgb(59 130 246);
    --theme-secondary-text: rgb(219 234 254);
    
    --theme-danger: rgb(248 113 113);
    --theme-danger-dark: rgb(239 68 68);
    --theme-danger-darker: rgb(220 38 38);
    
    --theme-border: rgb(55 65 81);
    --theme-border-dark: rgb(75 85 99);
    
    --theme-text: rgb(243 244 246);
    --theme-text-secondary: rgb(209 213 219);
    --theme-text-muted: rgb(156 163 175);
    
    --theme-paper: rgb(31 41 55);
    --theme-paper-hover: rgb(55 65 81);
    --theme-paper-active: rgb(75 85 99);
  }
`;
// 어두운 배경 오버레이 (모달 전용)
export const ModalOverlay = styled.div`
  position: fixed;
  inset: 0;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 9998; /* 모달 본체(9999) 바로 아래 */
  pointer-events: auto;
`;
export const HeaderGradientOverlay = styled.div`
  position: absolute;
  inset: 0;
  background: linear-gradient(
    135deg,
    rgba(16, 185, 129, 0.05) 0%,
    rgba(20, 184, 166, 0.05) 50%,
    rgba(6, 182, 212, 0.05) 100%
  );
  
  .dark & {
    background: linear-gradient(
      135deg,
      rgba(52, 211, 153, 0.1) 0%,
      rgba(45, 212, 191, 0.1) 50%,
      rgba(34, 211, 238, 0.1) 100%
    );
  }
`;
export const ResizeHandle = styled.div`
  position: absolute;
  opacity: 0;
  transition: opacity 0.2s;
  cursor: ${(props)=>props.$direction}-resize;
  touch-action: none;
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  user-select: none;
  pointer-events: auto;
  z-index: 30;
  
  &:hover {
    opacity: 1;
  }
  
  ${(props)=>{
    switch(props.$direction){
        case 'n':
            return css`
        top: 0;
        left: 50%;
        transform: translateX(-50%);
        height: 0.5rem;
        width: 2rem;
      `;
        case 's':
            return css`
        bottom: 0;
        left: 50%;
        transform: translateX(-50%);
        height: 0.5rem;
        width: 2rem;
      `;
        case 'e':
            return css`
        top: 50%;
        right: 0;
        transform: translateY(-50%);
        width: 0.5rem;
        height: 2rem;
      `;
        case 'w':
            return css`
        top: 50%;
        left: 0;
        transform: translateY(-50%);
        width: 0.5rem;
        height: 2rem;
      `;
        case 'nw':
            return css`
        top: 0;
        left: 0;
        height: 1rem;
        width: 1rem;
      `;
        case 'ne':
            return css`
        top: 0;
        right: 0;
        height: 1rem;
        width: 1rem;
      `;
        case 'sw':
            return css`
        bottom: 0;
        left: 0;
        height: 1rem;
        width: 1rem;
      `;
        case 'se':
            return css`
        bottom: 0;
        right: 0;
        height: 1rem;
        width: 1rem;
      `;
        default:
            return '';
    }
}}
`;
export const ResizeHandleIndicator = styled.div`
  width: 100%;
  height: 100%;
  background: linear-gradient(135deg, rgb(16 185 129), rgb(20 184 166));
  opacity: 0.7;
  border-radius: 9999px;
  
  .dark & {
    background: linear-gradient(135deg, rgb(52 211 153), rgb(45 212 191));
  }
`;
